import React, { useState, useEffect } from "react";
import { txtA, txtE } from "../../../Label/Lbl";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useInvCa, useInvMain } from "../../../St/Reviews/UseStyle";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { mergColumns } from "../ShareFunctionsPrint";

export const useStylesCashNotax = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        // minHeight: "100%",
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3),
    },
    itemW: {
        // width: '100%',
        fontSize: "0.6rem",
        //  fontWeight:'700',
        fontWeight: "bold",

        textAlign: "left",
    },
    allWidth: {
        fontSize: "0.8rem",
        //  fontWeight:'700',
        fontWeight: "bold",
    },
    checStyl: {
        border: "solid 2px",
        // width: '100%',
        fontSize: "0.8rem",
        //  fontWeight:'700',
        fontWeight: "bold",
        textAlign: "center",
        marginLeft: "-0.2cm",
        marginRight: "-0.2cm",
    },
    checStyl11: {
        // border: 'solid 2px',
        // width: '100%',
        fontSize: "0.78rem",
        //  fontWeight:'700',
        fontWeight: "bold",
        textAlign: "center",
        marginLeft: "-0.2cm",
        marginRight: "-0.2cm",
    },
    checStyl2: {
        // width: '100%',
        fontSize: "0.7rem",
        //  fontWeight:'700',
        fontWeight: "bold",

        textAlign: "right",
        marginBottom: 2,
    },
    checStyl3: {
        border: "solid 1px",
        fontSize: "0.6rem",
        fontWeight: "bold",
        textAlign: "center",
        padding: "7px 1px",
    },
    checStyl4: {
        border: "solid 1px",

        fontSize: "0.5rem",
        //  fontWeight:'700',
        fontWeight: "bold",
        textAlign: "center",
        padding: "5px 1px",
    },
    checStyl5: {
        fontSize: "0.6rem",
        //  fontWeight:'700',
        fontWeight: "bold",
        textAlign: "center",
        padding: "3px 1px",
    },
    checStyl6: {
        border: "solid 1px",
        fontSize: "0.6rem",
        fontWeight: "bold",
        textAlign: "center",
        padding: "3px 1px",
    },
}));

const BodyCash = (props) => {
    const { data, sta, locInv, inv, onUnmountComplete } = props;
    const clas = useInvCa();
    const [AE, setAE] = useState(null);
    const classes = useStylesCashNotax();
    const styleE = {
        border: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        fontSize: "0.9rem",
        color: "black",
        fontWeight: "bold",
    };

    const cellSName = {
        padding: "0px 0px",
        textAlign: "-webkit-center",
        margin: "0px",
        whiteSpace: "normal",
        border: "solid 0.1px",
        fontSize: "0.7rem",
        width: "600px",
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
    };
    const cellS = {

        padding: "0px 0.1px",
        textAlign: "-webkit-center",
        margin: "0px",
        whiteSpace: "normal",
        border: "solid 0.1px",
        fontSize: "0.65rem",
        width: "250px",
        textAlign: "right",
        paddingRight: "0.7rem",
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem"
    };

    const newData = data.map((row, i) => {
        return {
            ...row,
            no: i + 1,
            tot_net_curr: parseFloat(row.tot_net_curr).toFixed(2),
            new_exchange_price: parseFloat(row.new_exchange_price).toFixed(2),
        };
    });

    useEffect(() => {
        setTimeout(async () => {
            onUnmountComplete();
        }, 0);
    }, []);
    const styleCe = {
        fontFamily: "Amiri-Regular",
        border: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        fontSize: "0.65rem",
        color: "black",
        fontWeight: "bold",
        padding: "0.1px"
    };

    const totalsContntA_ = () => {
        return (
            <Grid item container className={clas.BdytotSub}>
                <Grid item xs={8} className={clas.BdytotCntr}>
                    <Grid item xs={12} >
                        {sta.StngIA.amountWithVatA}
                    </Grid>
                    <Grid item xs={12}>
                        {sta.StngIA.amountWithVatE}
                    </Grid>
                </Grid>
                <Grid item xs={4} className={clas.BdytotCntrVal}>
                    <div style={{ fontWeight: "bold", fontSize: "1rem" }}>{sta.tot.amountWithVat?.toFixed(2)}</div>
                </Grid>

                <Grid item xs={8} className={clas.BdytotCntr}>
                    {sta.StngIA.totdiscountA + " " + sta.StngIA.totdiscountE}
                </Grid>
                <Grid item xs={4} className={clas.BdytotCntrVal}>
                    {sta.tot.discount?.toFixed(2)}
                </Grid>

                <Grid item xs={8} className={clas.BdytotCntr}>
                    <Grid item xs={12}>
                        {sta.StngIA.amountWithVat2A}
                    </Grid>
                    <Grid item xs={12}>
                        {sta.StngIA.amountWithVat2E}
                    </Grid>
                </Grid>
                <Grid item xs={4} className={clas.BdytotCntrVal}>
                    {sta.tot.amountWithVat?.toFixed(2)}
                </Grid>

                <Grid item xs={8} className={clas.BdytotCntr}>
                    <Grid item xs={12}>
                        {sta.StngIA.amountOfVatA}
                    </Grid>
                    <Grid item xs={12}>
                        {sta.StngIA.amountOfVaEt}
                    </Grid>
                </Grid>
                <Grid item xs={4} className={clas.BdytotCntrVal}>
                    {sta.tot.amountOfVat?.toFixed(2)}
                </Grid>

                <Grid item xs={8} className={clas.BdytotCntr}>
                    <Grid item xs={12}>
                        {sta.StngIA.tot_netA}
                    </Grid>
                    <Grid item xs={12}>
                        {sta.StngIA.tot_netE}
                    </Grid>
                </Grid>
                <Grid item xs={4} className={clas.BdytotCntrVal}>
                    {sta.tot.tot_net?.toFixed(2)}
                </Grid>
            </Grid>
        );
    };

    const totalsContntE_ = () => {
        return (
            <Grid item container className={classes.checStyl2}>
                <Grid item xs={4} className={classes.checStyl5}>
                    <div style={{ fontWeight: "bold", fontSize: "0.9rem" }}>
                        {/* {(sta.tot.tot_net - sta.tot.amountOfVat + sta.tot.discount)?.toFixed(2)}  */}
                        {((sta?.tot?.tot_net - sta?.tot?.amountOfVat + sta?.tot?.discount) - parseFloat(sta?.tot?.tab3Vat ?? 0))?.toFixed(2)}

                    </div>
                </Grid>
                <Grid item xs={8} className={classes.checStyl2}>
                    <Grid item className={classes.checStyl5} style={{ fontWeight: "bold", fontSize: "0.8rem" }} xs={12}>
                        الاجمالي قبل الضريبة
                    </Grid>
                </Grid>

                <Grid item xs={4} className={classes.checStyl5} style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
                    <div style={{ fontWeight: "bold", fontSize: "1rem" }}>
                        {sta.tot.discount?.toFixed(2)} </div>
                </Grid>
                <Grid item xs={8} className={classes.checStyl5} style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
                    {txtE.totdiscount + " " + txtA.totdiscount}
                </Grid>

                <Grid item xs={4} className={classes.checStyl5}>
                    <div style={{ fontWeight: "bold", fontSize: "0.9rem" }}>
                        {/* {(sta.tot.tot_net - sta.tot.amountOfVat)?.toFixed(2)} */}
                        {((sta?.tot?.tot_net - sta?.tot?.amountOfVat) - parseFloat(sta?.tot?.tab3Vat ?? 0))?.toFixed(2)}

                    </div>
                </Grid>
                <Grid item xs={8} className={classes.checStyl5} style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
                    <Grid item xs={12}>
                        الاجمالي الخاضع للضريبة
                    </Grid>
                </Grid>
                {parseFloat(sta?.tot?.tab3Vat) > 0 &&
                    (
                        <>
                            <Grid item xs={4} className={classes.checStyl5}>
                                <div style={{ fontWeight: "bold", fontSize: "0.9rem" }}>
                                    {sta?.tot?.tab3Vat?.toFixed(2)}</div>
                            </Grid>
                            <Grid item xs={8} className={classes.checStyl5}>
                                <Grid item className={classes.checStyl5} xs={12} style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
                                    {"مجموع ضريبة التبغ"}
                                </Grid>
                            </Grid>
                        </>
                    )}
                <Grid item xs={4} className={classes.checStyl5}>
                    <div style={{ fontWeight: "bold", fontSize: "0.9rem" }}>
                        {sta.tot.amountOfVat?.toFixed(2)}</div>
                </Grid>
                <Grid item xs={8} className={classes.checStyl5}>
                    <Grid item className={classes.checStyl5} xs={12} style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
                        {"إجمالي الضريبة"} {"("}{inv.tax}{"%"}{")"}
                    </Grid>
                </Grid>

                <Grid item className={classes.checStyl6} xs={4}>
                    <div style={{ fontWeight: "bold", fontSize: "0.9rem" }}>
                        {sta.tot.tot_net?.toFixed(2)}</div>
                </Grid>
                <Grid item className={classes.checStyl6} style={{ fontWeight: "bold", fontSize: "0.8rem" }}
                    xs={8}>
                    <Grid item className={classes.checStyl5} style={{ fontWeight: "bold", fontSize: "0.8rem" }} xs={12}>
                        الاجمالي شامل الضريبه
                    </Grid>
                </Grid>
                <Grid item className={classes.checStyl6} style={{ fontWeight: "bold", fontSize: "0.8rem" }} xs={6}>
                    {" متبقي"}
                    {"\n"}
                    {sta.tot?.inv_type_name == "نقدية"
                        ? 0
                        : sta?.tot?.tot_net?.toFixed(2) - sta?.tot?.paid}
                </Grid>
                <Grid item className={classes.checStyl6} style={{ fontWeight: "bold", fontSize: "0.8rem" }} xs={6}>
                    {" مدفوع"}
                    {"\n"}
                    {sta?.tot?.inv_type_name == "نقدية"
                        ? sta?.tot?.tot_net?.toFixed(2)
                        : sta?.tot?.paid}
                </Grid>

                <Grid item className={classes.checStyl6} style={{ fontWeight: "bold", fontSize: "0.8rem" }} xs={5}>
                    {" بعد"}
                    {"\n"}
                    {sta.tot?.cust_balance_new?.toFixed(2)}
                </Grid>
                <Grid item className={classes.checStyl6} style={{ fontWeight: "bold", fontSize: "0.8rem" }} xs={5}>
                    {" قبل"}
                    {"\n"}
                    {/* {sta.tot?.cust_balance_old?.toFixed(2)} */}
                    {inv.ProcType_InvProc === "11" || inv.ProcType_InvProc === "12" ? (parseFloat(sta.tot?.cust_balance_new) + parseFloat(inv.agel_part))?.toFixed(2)
                        : (parseFloat(sta.tot?.cust_balance_new) - parseFloat(inv.agel_part))?.toFixed(2)}
                </Grid>
                <Grid item className={classes.checStyl6} style={{ fontWeight: "bold", fontSize: "0.8rem" }} xs={2}>
                    {"الرصيد "}
                </Grid>

                <Grid item xs={2}>
                    <Typography className={classes.checStyl5} xs={12}>
                        {sta?.info?.reduce(
                            (sum, item) => Number(sum) + Number(item.val1),
                            0
                        )}
                    </Typography>
                </Grid>
                <Grid item xs={4} className={classes.checStyl5}>
                    اجمالي الكمية{" "}{sta?.info?.reduce(
                            (sum, item) => Number(sum) + Number(item.val1),
                            0
                        )}
                </Grid>

                <Grid item xs={2}>
                    <Typography className={classes.checStyl5} xs={12}>
                        {sta?.info?.length}
                    </Typography>
                </Grid>
                <Grid item xs={4} className={classes.checStyl5}>
                    ItemsCount{" "}
                </Grid>
            </Grid>
        );
    };

    return (
        <Grid item container className={clas.Bdyroot}>
            <Grid item container className={clas.BdyundrHeaderTF}>
                {locInv.ProcTypeInvProc != "03" && parseFloat(sta?.tot?.amountOfVat) > 0 && (
                    <Grid item xs={12}>
                        <Typography className={classes.checStyl11}>
                            {sta.tot?.tax_no_cust === ""
                                ? "فاتورة ضريبية مبسطة"
                                : "فاتورة ضريبية"}
                        </Typography>
                    </Grid>
                )}

                <Grid item xs={12}>
                    <Typography className={classes.checStyl}>
                        {locInv.invN +
                            " " +
                            sta.tot.inv_type_name +
                            " " +
                            sta.tot.pay_type_name}
                    </Typography>
                </Grid>
            </Grid>

            <Grid
                item
                container
                style={{ border: "solid 1px #000", marginBottom: 5, padding: 3 }}
            >
                <Grid item xs={3} className={classes.checStyl2}>
                    <Paper>{sta.tot?.refno}</Paper>
                </Grid>
                <Grid xs={3} className={classes.checStyl2}>
                    {"رقم المرجع"}
                </Grid>

                <Grid item xs={3} className={classes.checStyl2}>
                    {sta.tot.id}
                </Grid>
                <Grid xs={3} className={classes.checStyl2}>
                    {txtA.invNumr}
                </Grid>

                <Grid xs={4} className={classes.checStyl2}>
                    {moment(sta.tot.date).format("hh:mm A")}
                </Grid>

                <Grid xs={4} className={classes.checStyl2}>
                    {moment(sta.tot.date).format("YYYY/MM/DD")}
                </Grid>
                <Grid xs={4} className={classes.checStyl2}>
                    {txtA.invDate}
                </Grid>

                <Grid xs={8} className={classes.checStyl2}>
                    <div style={{ fontWeight: "0.7" }}>{sta.tot.cust_name}</div>
                </Grid>
                <Grid xs={4} className={classes.checStyl2}>
                    {txtA.custmName}
                </Grid>
                <Grid xs={8} className={classes.checStyl2}>
                    {sta?.tot?.cust_address + " - " + sta?.tot?.cust_mobile}
                </Grid>
                <Grid xs={4} className={classes.checStyl2}>
                    {"بيانات العميل"}
                </Grid>
                <Grid xs={6}>
                    <Paper className={classes.checStyl2}>{sta.tot?.tax_no_cust}</Paper>
                </Grid>
                <Grid xs={6} className={classes.checStyl2}>
                    {txtA.taxNumr}
                </Grid>

            </Grid>
            <Grid container xs={12}>
                <Grid item xs={1} style={styleE}>
                    {"#"}
                </Grid>
                <Grid item xs={3} style={styleE}>
                    {"اسم الصنف"}
                </Grid>
                <Grid item xs={2} style={styleE}>
                    {"الوحده"}
                </Grid>
                <Grid item xs={2} style={styleE}>
                    {"الكمية"}
                </Grid>
                <Grid item xs={2} style={styleE}>
                    {"السعر"}
                </Grid>
                <Grid item xs={2} style={styleE}>
                    {"الاجمالي"}
                </Grid>
                {newData?.map((d) => {
                    return (
                        <Grid
                            xs={12}
                            container
                            item
                            style={{ width: "100%" }}
                        >
                            <Grid item xs={1} style={styleCe}>
                                {d.no}
                            </Grid>
                            <Grid item xs={3} style={cellSName}>
                            {mergColumns(d.symbol, d?.nameEN)}
                            </Grid>
                            <Grid item xs={2} style={styleCe}>
                                {d.unit_name}
                            </Grid>
                            <Grid item xs={2} style={styleCe}>
                                {d.val1}
                            </Grid>
                            <Grid item xs={2} style={styleCe}>
                                {d?.priceC}
                            </Grid>
                            <Grid item xs={2} style={styleCe}>
                                {d?.netTotal}
                            </Grid>
                        </Grid>
                    );
                })}
            </Grid>
            {AE ? totalsContntA_() : totalsContntE_()}
        </Grid>
    );
};
export default BodyCash;
